import App from './App.svelte';
import AgentTesting from './AgentTesting.svelte';

// Route based on hash: #agent loads a separate root component (the dev tool);
// everything else is the admin App, whose in-app hash router (store/router.js)
// handles all other hash navigation without reloading the page.
const isAgentMode = () => window.location.hash === '#agent';

var app;

if (isAgentMode()) {
	app = new AgentTesting({
		target: document.body
	});
} else {
	app = new App({
		target: document.body
	});
}

// Only reload when crossing the #agent boundary (which swaps the root
// component). All other hash changes are handled by the in-app router.
let wasAgent = isAgentMode();
window.addEventListener('hashchange', () => {
	const nowAgent = isAgentMode();
	if (nowAgent !== wasAgent) {
		window.location.reload();
	}
	wasAgent = nowAgent;
});

export default app;